export default "__VITE_ASSET__C3BpjC0I__"